import type { ReactNode } from "react";
import "./DualMonthPane.scss";
import useGetDayPickerLocale from "@/shared/custom-hook/useGetDayPickerLocale.ts";
import MonthPane from "@/pages/human-resources/time-management/components/date-navigator/monthly-date-navigator/dual-month-pane/MonthPane.tsx";
import Button from "@/shared/components/generic/button/Button.tsx";
import { Size } from "@/shared/components/generic/UiEnums.ts";
import { useTranslation } from "react-i18next";
import useDualMonthPaneController from "@/pages/human-resources/time-management/components/date-navigator/monthly-date-navigator/dual-month-pane/useDualMonthPaneController.ts";

interface Properties {
  startDate: Date;
  endDate: Date;
  timeZone: string;
  onChange: (startDate: Date) => void;
}

export default function DualMonthPane(props: Properties): ReactNode {
  const locale = useGetDayPickerLocale();
  const { t } = useTranslation("common");
  const controller = useDualMonthPaneController(props.startDate, props.endDate);

  return (
    <div className="dual-month-pane">
      <div className="months-pane">
        <MonthPane
          locale={locale}
          displayMonthDate={controller.leftDisplayDate}
          selectedRange={controller.selectedRange}
          timeZone={props.timeZone}
          onPickDay={controller.changeRangeToStartAt}
          startEnd={"start"}
          onClickMove={controller.displayPreviousMonth}
        />
        <MonthPane
          locale={locale}
          displayMonthDate={controller.rightDisplayDate}
          selectedRange={controller.selectedRange}
          timeZone={props.timeZone}
          onPickDay={controller.changeRangeToEndAt}
          startEnd={"end"}
          onClickMove={controller.displayNextMonth}
        />
      </div>
      <div className="footer">
        <Button
          onClick={() => {
            props.onChange(controller.selectedRange.from);
          }}
          label={t("actions.validate")}
          size={Size.SMALL}
        />
      </div>
    </div>
  );
}
